export const IOS_DOWNLOAD_PRESS = 'website_download_ios'
export const ANDROID_DOWNLOAD_PRESS = 'website_download_android'
export const GET_APP_PRESS = 'website_get_app'
export const GET_APP_SMSF_PRESS = 'website_get_app_smsf'
